module.exports = __webpack_public_path__ + "img/pictoPresentation2.507d9621.svg";